$(document).ready(function () {
    $modal = $('#message');
    $modal.modal('show').find('.alert button').on('click', function () {
        $modal.modal('hide');
    });
    setTimeout(function () {
        $modal.modal('hide');
    }, 25000);
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-message.js